import { render, staticRenderFns } from "./handzettelBack.vue?vue&type=template&id=489ae439&scoped=true&"
import script from "./handzettelBack.vue?vue&type=script&lang=js&"
export * from "./handzettelBack.vue?vue&type=script&lang=js&"
import style0 from "./handzettelBack.vue?vue&type=style&index=0&id=489ae439&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ae439",
  null
  
)

export default component.exports